import firstImg from '../assets/img/Office worker with dumbells.svg'
import secondImg from '../assets/img/Happy african woman.svg'
import thirdImg from '../assets/img/Portrait of student smiling while looking into camera.svg'

const usesData = [
    {
        index: 0,
        use: 'Track personal and organizational goals.',
        details: 'Our performance management system allows you to align individual goals with organizational goals, ensuring that everyone in your organization is working towards the same objectives. You can easily monitor progress toward goals at both the individual and team levels, giving you a comprehensive view of performance across your organization.',
        image: firstImg,
        itemclass: 'firstCont'
    },
    {
        index: 1,
        use: 'Monitor employee progress towards goals',
        details: 'By tracking progress toward goals, you can recognize and reward employees who are performing at a high level, boosting employee morale and increasing retention. With our performance management system, you can achieve better business outcomes and build a high-performing workforce.',
        image: secondImg,
        itemclass: 'secondCont'
    },
    {
        index: 2,
        use: 'Integrate with HR systems such as payroll.',
        details: 'With our performance management system, you can integrate seamlessly with your HR systems, such as payroll, streamlining your HR processes and improving data accuracy. This enables you to focus on more strategic initiatives and build a more efficient and effective HR function.',
        image: thirdImg,
        itemclass: 'thirdCont'
    }
]

export default usesData